export function formatCurrency(val: string): string {
    if (!val) return '$0';
    const digits = val.replace(/\D/g, '');
    if (!digits) return '$0';
    return '$' + Number(digits).toLocaleString('es-CO');
}

export function isValidEmail(val: string): boolean {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val);
}
